import React, { useEffect, useRef } from 'react';

import gsap from 'gsap';

interface AnimatedNumberProps {
  value: number;
  time: number;
  startValue?: number;
  className?: string;
  suffix?: string;
}

export const AnimatedNumber: React.FC<AnimatedNumberProps> = ({
  value,
  time,
  startValue = 0,
  className,
  suffix = '',
}) => {
  const ref = useRef<HTMLParagraphElement>(null);
  const tweenRef = useRef<gsap.core.Tween | null>(null);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;

    const obj = { val: startValue };

    tweenRef.current = gsap.to(obj, {
      val: value,
      duration: time / 1000,
      ease: 'power3.out',
      onUpdate: () => {
        el.textContent = `${Math.round(obj.val).toLocaleString('en-US')}${suffix}`;
      },
    });

    return () => {
      tweenRef.current?.kill();
    };
  }, [value, time, startValue, suffix]);

  return (
    <p ref={ref} className={className}>
      {startValue.toLocaleString('en-US')}
      {suffix}
    </p>
  );
};
